<template>
  <div>
    <h3>What is your Date of Birth?</h3>
    <v-form-group icon="calendar" :validator="$v.birthDate" label="Select date">
      <date-picker 
        slot-scope="{ attrs, listeners }"
        v-bind="attrs"
        v-on="listeners"
        placeholder="Select date"
        v-model="survey.birthDate"
      >
      </date-picker>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { isAdult } from "utils/custom-validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      birthDate: {
        required,
        isAdult
      }
    },

    computed: {
      ...mapState(["survey"]),

      birthDate() { return this.survey.birthDate }
    },

    methods: {
      onSubmit() {
      }
    }
  };
</script>